import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const IncludedList = ({ items, serviceName }) => (
  <section data-testid="included-section" aria-labelledby="included-heading" className="section section-alt">
    <div className="container-site">
      <Reveal className="max-w-[720px]">
        <h2 id="included-heading">What&rsquo;s Included in Our {serviceName} Service</h2>
      </Reveal>
      <ul className="mt-10 grid gap-x-8 gap-y-4 md:grid-cols-2">
        {items.map((item, i) => (
          <Reveal as="li" key={item} delay={i * 60} className="flex items-start gap-3 text-base text-body">
            <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand text-white">
              <Check size={14} strokeWidth={3} aria-hidden="true" />
            </span>
            {item}
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
